import { useEffect, useState } from 'react';
import { Navigate, useLocation } from 'react-router-dom';
import { getCurrentUser } from 'aws-amplify/auth';

export default function ProtectedRoute({ children }) {
  const location = useLocation();
  const [state, setState] = useState({ checking: true, authed: false });

  useEffect(() => {
    let cancelled = false;
    getCurrentUser()
      .then(() => !cancelled && setState({ checking: false, authed: true }))
      .catch(() => !cancelled && setState({ checking: false, authed: false }));
    return () => {
      cancelled = true;
    };
  }, []);

  if (state.checking) {
    return <div className="admin-loading">Checking session…</div>;
  }
  if (!state.authed) {
    return <Navigate to="/admin/login" replace state={{ from: location }} />;
  }
  return children;
}
